export enum LogLevel {
    DEBUG = 0,
    WARN = 1,
    ERROR = 2,
}

export function log(level: LogLevel, ...args: any) {
    if (level < siteConfig.logLevel) {
        return
    }

    if (level === LogLevel.DEBUG) {
        // biome-ignore lint/suspicious/noConsoleLog: Every console.log should be a log(). Ignored to removed debug console.logs before pushing
        console.log(...args)
    } else if (level === LogLevel.WARN) {
        console.warn(...args)
    } else if (level === LogLevel.ERROR) {
        console.error(...args)
    }
}
